export const FIRST_PASSWORD_MODAL_TEXTS = {
  title: 'Crie sua senha',
  description:
    'Hoje você entra pelo código ou link que enviamos ao seu e-mail. Crie uma senha para entrar com seu e-mail e senha.',
  passwordLabel: 'Senha',
  confirmationLabel: 'Confirmar senha',
  mismatch: 'As senhas não coincidem.',
  later: 'Agora não',
  submit: 'Criar senha',
  close: 'Fechar',
  success:
    'Senha criada. No próximo acesso, entre com seu e-mail e essa senha.',
  alreadyCreated: 'Sua conta já tem uma senha.',
  genericError: 'Não foi possível criar sua senha. Tente novamente.',
} as const;
